import { Link } from 'gatsby';
import { OutboundLink } from '../../utils/analytics';
import Logo from '../../assets/images/logo.svg';

const BLOCKS: {
  label?: string;
  classNames?: string;
  links: {
    label: string;
    href: string;
    innerRoute?: boolean;
  }[];
}[] = [
  {
    label: 'Follow us:',
    links: [
      {
        label: 'Twitter',
        href: 'https://twitter.com/devfest_ukraine/',
      },
      {
        label: 'Instagram',
        href: 'https://www.instagram.com/devfestukraine/',
      },
      {
        label: 'Facebook',
        href: 'https://www.facebook.com/devfest.ukraine',
      },
      {
        label: 'LinkedIn',
        href: 'https://www.linkedin.com/events/devfestforukraine6930874707453845505',
      },
      {
        label: 'YouTube',
        href: 'https://www.youtube.com/c/GDGLviv/',
      },
      {
        label: 'TikTok',
        href: 'https://www.tiktok.com/@devfestukraine',
      },
      {
        label: 'Medium',
        href: 'https://medium.com/gdg-lviv',
      },
    ],
  },
  {
    links: [
      {
        label: 'Email us',
        href: 'mailto:devfest@gdg.org.ua',
      },
      {
        label: 'Code of Conduct',
        href: '/code-of-conduct',
        innerRoute: true,
      },
      {
        label: 'Team',
        href: '/team',
        innerRoute: true,
      },
      {
        label: 'Press release',
        href: '/press-release',
        innerRoute: true,
      },
    ],
  },
  {
    label: 'Explore Past DevFests:',
    classNames: 'col-start-1 col-end-3 md:col-start-auto md:col-end-auto',
    links: [
      {
        label: 'DFUA 2014',
        href: 'https://2014.devfest.gdg.org.ua/',
      },
      {
        label: 'DFUA 2015',
        href: 'https://2015.devfest.gdg.org.ua/',
      },
      {
        label: 'DFUA 2016',
        href: 'https://2016.devfest.gdg.org.ua/',
      },
      {
        label: 'DFUA 2017',
        href: 'https://2017.devfest.gdg.org.ua/',
      },
      {
        label: 'DFUA 2018',
        href: 'https://2018.devfest.gdg.org.ua/',
      },
      {
        label: 'Love.Tech.Problems',
        href: 'https://2020.devfest.gdg.org.ua/',
      },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="container mx-auto py-12 md:py-24 px-4 flex flex-col md:items-center">
      <div className="grid gap-8 md:gap-16 grid-cols-2 md:grid-cols-[max-content_1fr_1fr_1fr] reveal fade-bottom">
        <img
          className="h-6 lg:h-8 col-start-1 col-end-3 md:col-end-auto"
          src={Logo}
          alt="GDG DevFest Ukraine 2022"
        />

        {BLOCKS.map(({ label, links, classNames }, index) => (
          <nav key={index} className={classNames}>
            {label && <h5 className="mb-2 text-xl">{label}</h5>}
            <ul>
              {links.map(({ label, href, innerRoute = false }) => (
                <li key={label} className="mb-2">
                  {innerRoute ? (
                    <Link to={href} className="underline underline-offset-4">
                      {label}
                    </Link>
                  ) : (
                    <OutboundLink
                      href={href}
                      className="underline underline-offset-4"
                      target="_blank"
                    >
                      {label}
                    </OutboundLink>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
    </footer>
  );
};
